import React, { useEffect } from 'react';

import { getSiteWithId } from '../utils';
import Dropdown from './Dropdown';
import { FormContent } from '../../booking/components/Form';
import { Api } from '../../common/model';

interface Props {
  label: string;
  sites: Array<Api.Site>;
  content: FormContent;
  onChanged: (info: FormContent) => void;
  forceValidation: boolean;
}

function MeetingPoint({ label, sites, content, onChanged, forceValidation }: Props) {
  const [siteName, setSiteName] = React.useState('');

  const siteCheckpoints = (site: string | undefined) => {
    if (site && site.length > 0) {
      const target = getSiteWithId(sites, site);
      return target ? target.checkpoints : [];
    }
    return [];
  };

  useEffect(() => {
    const site = getSiteWithId(sites, content.site);
    if (site) setSiteName(site.name);
  }, [sites, content.site]);

  return (
    <div className="MeetingPoint">
      <div className="label">{label} *</div>
      <div className="selector">
        <div className="site">{siteName}</div>
        <div className="checkpoint">
          <Dropdown
            name="checkpoint"
            prefix="start"
            items={siteCheckpoints(content?.site)}
            value={content.checkpoint}
            fastBooking={false}
            forceValidation={forceValidation}
            onChange={checkpoint => onChanged({ ...content, checkpoint })}
          />
        </div>
      </div>
    </div>
  );
}

export default MeetingPoint;
